import { alpha as r } from "@theme-ui/color";
const c = {
  primary: {
    bg: "primary",
    color: "white"
  },
  accent: {
    bg: "accent",
    color: "primary"
  },
  default: {
    bg: "cardOverlay",
    color: "primary"
  },
  secondary: {
    bg: r("black", 0.4),
    color: "white"
  },
  success: {
    bg: "success",
    color: "white"
  }
}, a = {
  tags: c
};
export {
  a as tagsTheme
};
